export default "__VITE_ASSET__m2OpV0TX__"